// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_bead_cord_bore/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_bead_cord_bore: ModuleSchema = {
  "id": "core_bead_cord_bore",
  "uniqueId": "B3D_3FK5T",
  "createdAt": "2026-10-14T19:00:00Z",
  "updatedAt": "2026-10-28T14:57:47.761Z",
  "label": "Bead Cord Bore",
  "description": "Reusable horizontal cord-hole cutter for bead bodies (CG_BRB01).",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_BRB01",
    "bead",
    "cord-bore"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Body Width (mm)",
      "min": 12,
      "max": 100,
      "default": 36,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Body Height (mm)",
      "min": 8,
      "max": 80,
      "default": 20,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Body Depth (mm)",
      "min": 1,
      "max": 30,
      "default": 10,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "holeDiameter",
      "label": "Cord Hole Diameter (mm)",
      "min": 1,
      "max": 12,
      "default": 5,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "holeYOffset",
      "label": "Hole Vertical Offset (mm)",
      "min": -20,
      "max": 20,
      "default": 0,
      "step": 0.5,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "body",
      "label": "Body",
      "default": "#64748B",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
